import dateHelper from '../../../helpers/date.js'

export default{

    getLastSuggestionGroup : state => {
        return state.game.lastSuggestionsGroup
    },
    getLastSuggestionSelf : state => {
        return state.game.lastSuggestionSelf
    },
    getGroup : state => {
        return state.game.group
    },
    getStartGame: state => {
        let stateStart = state.game.startGame
        if(!stateStart){
            
        }

        return stateStart
    },
    getOpenedEnigma: state => {
        // console.log("getted enigma: ", state.game.enigmas)
        return state.game.enigmas
    }
}